import styled, { css } from 'styled-components'

import { BRAND } from 'constants/appConstants'
import { theme } from 'utils/theme'

export const CardContainer = styled.div`
  position: relative;
  height: ${props => props.itemHeight || '225px'};
  ${props => props.featured && props.theme.brand === BRAND.ATH && `border-bottom: 4px solid ${theme.colors.lightGold}`};
  img {
    height: 100%;
    object-fit: cover;
  }
`

export const Gradient = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.71) 0%, rgba(0, 0, 0, 0) 61.54%);
  position: absolute;
  top: 0;
`

export const IconContainer = styled.div`
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: ${theme.colors.alfaLightGold};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -30px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;

  .icon-container {
    left: 3px;
  }
`

export const Title = styled.div`
  position: absolute;
  bottom: 0;
  font-weight: 700;
  line-height: 40px;
  padding: 16px;

  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          font-family: Bison;
          font-size: 36px;
        `
      : css`
          font-family: 'Futura Std';
          font-size: 18px;

          &:after {
            content: '';
            height: 4px;
            width: 84px;
            background-color: ${theme.colors.gcadOrange};
            position: absolute;
            left: 16px;
            top: 4px;
          }
        `}
`

export const ContentTypeFlag = styled.div`
  position: absolute;
  top: 0;
  background: ${theme.colors.primaryRed};
  background: ${({ theme: { brand } }) => (brand === BRAND.GCAD ? theme.colors.black : theme.colors.primaryRed)};
  padding: 6px 12px;

  span {
    font-family: AzoSans;
    font-weight: 600;
    font-size: ${({ theme: { brand } }) => (brand === BRAND.GCAD ? '18px' : '28px')};
    line-height: ${({ theme: { brand } }) => (brand === BRAND.GCAD ? '22px' : '32px')};
    text-transform: capitalize;
  }
`
